import Vue from 'vue'
import ApiBase from '@/api/apiBase'

class ApiStatistics {


    static years(callBack, errorCallBack) {
        ApiBase.get(`/statistics/get_years`, callBack, ApiBase.noParse, errorCallBack)
    }

    static sportPlaces(callBack, errorCallBack) {
        ApiBase.get(`/statistics/get_sport_places`, callBack, ApiBase.noParse, errorCallBack)
    }

    static tournaments(callBack, errorCallBack) {
        ApiBase.get(`/statistics/get_tournaments`, callBack, ApiBase.noParse, errorCallBack)
    }

    static status(callBack, errorCallBack) {
        ApiBase.get(`/statistics/get_paid_status`, callBack, ApiBase.noParse, errorCallBack)
    }




    static registrations(data, callBack, errorCallBack) {
        /*let formData = new FormData()
        formData.append('name', player.name)
        formData.append('team_id', player.team_id)

        if(player.photo) {
            formData.append('photo', player.photo)
        }*/
        /*
        Route::get("statistics/get_suscriptions/{year_filter}/{sport_place_filter}/{tournament_filter}/{city_filter}/{paid_status_filter}", 'PitzAdminController@getSuscriptions');
        Route::get("statistics/get_suscriptions_csv/{year_filter}/{sport_place_filter}/{tournament_filter}/{city_filter}/{paid_status_filter}", 'PitzAdminController@getSuscriptionsCSV');
        */
        var d = {};
        var year_filter = 0
        var sport_place_filter = 0
        var tournament_filter = 0
        var city_filter = 0
        var paid_status_filter = 0
        if(data.year){
          year_filter = data.year.id
        }
        if(data.tournament){
          tournament_filter = data.tournament.id
        }
        if(data.status){
          paid_status_filter = data.status.id
        }
        if(data.sportPlace){
          sport_place_filter= data.sportPlace.id
        }


        ApiBase.get(`/statistics/get_suscriptions/${year_filter}/${sport_place_filter}/${tournament_filter}/${city_filter}/${paid_status_filter}`, callBack, ApiBase.noParse, errorCallBack)
    }

    static registrationsCSV(data, callBack, errorCallBack) {

        var d = {};
        var year_filter = 0
        var sport_place_filter = 0
        var tournament_filter = 0
        var city_filter = 0
        var paid_status_filter = 0
        if(data.year){
          year_filter = data.year.id
        }
        if(data.tournament){
          tournament_filter = data.tournament.id
        }
        if(data.status){
          paid_status_filter = data.status.id
        }
        if(data.sportPlace){
          sport_place_filter= data.sportPlace.id
        }


        ApiBase.get(`/statistics/get_suscriptions_csv/${year_filter}/${sport_place_filter}/${tournament_filter}/${city_filter}/${paid_status_filter}`, callBack, ApiBase.noParse, errorCallBack)
    }

}

export default ApiStatistics



// WEBPACK FOOTER //
// ./src/api/apiStatistics.js